import { Box, styled } from '@mui/material';
import { DesignTokens } from '../specify';

export const GivelifyPaper = styled(Box)(() => ({
    boxShadow: DesignTokens.shadow.shadowMedium,
    borderRadius: 20,
    overflow: 'auto',
    backgroundColor: 'white',
}));
